/**
 * HouseCrest — a small circular brass-medallion logo, embossed above each
 * house table's title like the crest that sits above a real casino dealer.
 * Renders inline SVG so it scales cleanly to any size and matches per-table
 * accent color (gold for BJ, cyan for 3CP + Craps, violet for Roulette).
 *
 * Sits in the felt banner just above the "BETOHALICS · GAME NAME" text —
 * looks silk-screened + embossed into the felt so it belongs on the table.
 */
export const HouseCrest = ({ size = 56, accent = '#FFD700', glow = 'rgba(255,215,0,0.55)' }) => {
    const glowSoft = glow.replace(/,\s*[\d.]+\)/, ', 0.35)');
    return (
        <svg
            viewBox="0 0 120 120"
            width={size}
            height={size}
            aria-label="BETohalics house crest"
            role="img"
            style={{ filter: `drop-shadow(0 0 8px ${glow}) drop-shadow(0 0 16px ${glowSoft})` }}
        >
            <defs>
                <radialGradient id={`crest-brass-${accent.replace('#','')}`} cx="50%" cy="35%" r="60%">
                    <stop offset="0%" stopColor="#fff6d6" />
                    <stop offset="30%" stopColor={accent} />
                    <stop offset="70%" stopColor={accent} stopOpacity="0.75" />
                    <stop offset="100%" stopColor="#000" stopOpacity="0.85" />
                </radialGradient>
                <linearGradient id={`crest-inner-${accent.replace('#','')}`} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#000" stopOpacity="0.75" />
                    <stop offset="100%" stopColor="#000" stopOpacity="0.95" />
                </linearGradient>
                <path id={`crest-arc-top-${accent.replace('#','')}`} d="M 20 60 A 40 40 0 0 1 100 60" fill="none" />
                <path id={`crest-arc-bot-${accent.replace('#','')}`} d="M 22 62 A 38 38 0 0 0 98 62" fill="none" />
            </defs>

            {/* Outer brass ring */}
            <circle cx="60" cy="60" r="56" fill={`url(#crest-brass-${accent.replace('#','')})`} stroke={accent} strokeWidth="1.2" />
            {/* Inner recessed disc — where the monogram sits */}
            <circle cx="60" cy="60" r="38" fill={`url(#crest-inner-${accent.replace('#','')})`} stroke={accent} strokeWidth="0.8" strokeOpacity="0.6" />

            {/* Arced "BETOHALICS" up top */}
            <text fill={accent} fontSize="9" fontWeight="800" letterSpacing="3" style={{ fontFamily: 'Cinzel, serif' }}>
                <textPath href={`#crest-arc-top-${accent.replace('#','')}`} startOffset="50%" textAnchor="middle">
                    BETOHALICS
                </textPath>
            </text>
            {/* Arced star cluster (bottom) */}
            <text fill={accent} fontSize="10" letterSpacing="6" style={{ fontFamily: 'Cinzel, serif' }}>
                <textPath href={`#crest-arc-bot-${accent.replace('#','')}`} startOffset="50%" textAnchor="middle">
                    ★ ★ ★
                </textPath>
            </text>

            {/* Center monogram "B" with a chip-suit motif */}
            <text
                x="60" y="70"
                textAnchor="middle"
                fill={accent}
                fontSize="34"
                fontWeight="900"
                style={{ fontFamily: 'Cinzel, serif', filter: `drop-shadow(0 0 4px ${glow})` }}
            >
                B
            </text>
        </svg>
    );
};

export default HouseCrest;
